// extracted by mini-css-extract-plugin
module.exports = {"notificationsListRoot":"NotificationPanel_notificationsListRoot__Nmoz2","header":"NotificationPanel_header__BUhDb","textItem":"NotificationPanel_textItem__DrCmg"};